import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import {
	canAccessEscalaEnfermagem,
	canAccessEscalaMultiprofissional,
	ESCALA_ENFERMAGEM_HABILITADA,
	ESCALA_MULTIPROFISSIONAL_HABILITADA,
} from '../../../utils/escalaFeatures';
import NavBar from '../../../components/NavBar';

const StethoscopeIcon = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='80'
		height='80'
		viewBox='0 0 80 80'
		fill='none'>
		<path
			d='M59.0625 21.875C60.5664 21.875 61.9792 22.1598 63.3008 22.7295C64.6224 23.2992 65.7731 24.0853 66.7529 25.0879C67.7327 26.0905 68.5189 27.2526 69.1113 28.5742C69.7038 29.8958 70 31.3086 70 32.8125C70 34.1113 69.7835 35.3532 69.3506 36.5381C68.9176 37.723 68.3138 38.7826 67.5391 39.7168C66.7643 40.651 65.8415 41.46 64.7705 42.1436C63.6995 42.8272 62.526 43.2943 61.25 43.5449V47.0312C61.25 49.0592 60.9993 51.0303 60.498 52.9443C59.9967 54.8584 59.2904 56.6813 58.3789 58.4131C57.4674 60.1449 56.3509 61.7057 55.0293 63.0957C53.7077 64.4857 52.238 65.7048 50.6201 66.7529C49.0023 67.8011 47.2363 68.5986 45.3223 69.1455C43.4082 69.6924 41.4258 69.9772 39.375 70C37.3014 70 35.319 69.7152 33.4277 69.1455C31.5365 68.5759 29.7819 67.7783 28.1641 66.7529C26.5462 65.7275 25.0765 64.5085 23.7549 63.0957C22.4333 61.6829 21.3167 60.1221 20.4053 58.4131C19.4938 56.7041 18.776 54.8926 18.252 52.9785C17.7279 51.0645 17.4772 49.082 17.5 47.0312V39.2041C14.6973 38.9535 12.2135 38.2812 10.0488 37.1875C7.88411 36.0938 6.0498 34.6582 4.5459 32.8809C3.04199 31.1035 1.91406 29.0413 1.16211 26.6943C0.410156 24.3473 0.0227865 21.8066 0 19.0723V0H10.9375C11.5299 0 12.0426 0.216471 12.4756 0.649414C12.9085 1.08236 13.125 1.59505 13.125 2.1875C13.125 2.77995 12.9085 3.29264 12.4756 3.72559C12.0426 4.15853 11.5299 4.375 10.9375 4.375H4.375V19.0723C4.375 21.4876 4.7054 23.6751 5.36621 25.6348C6.02702 27.5944 7.01823 29.2692 8.33984 30.6592C9.66146 32.0492 11.2565 33.1201 13.125 33.8721C14.9935 34.624 17.181 35 19.6875 35C21.9889 35 24.0853 34.6468 25.9766 33.9404C27.8678 33.2341 29.4743 32.2201 30.7959 30.8984C32.1175 29.5768 33.1543 27.9818 33.9062 26.1133C34.6582 24.2448 35.0228 22.137 35 19.79V4.375H28.4375C27.8451 4.375 27.3324 4.15853 26.8994 3.72559C26.4665 3.29264 26.25 2.77995 26.25 2.1875C26.25 1.59505 26.4665 1.08236 26.8994 0.649414C27.3324 0.216471 27.8451 0 28.4375 0H39.375V19.0723C39.375 21.8066 38.9876 24.3473 38.2129 26.6943C37.4382 29.0413 36.3102 31.1035 34.8291 32.8809C33.348 34.6582 31.5251 36.0938 29.3604 37.1875C27.1956 38.2812 24.7005 38.9535 21.875 39.2041V47.0312C21.875 49.4694 22.3079 51.805 23.1738 54.0381C24.0397 56.2712 25.2588 58.2536 26.8311 59.9854C28.4033 61.7171 30.249 63.0843 32.3682 64.0869C34.4873 65.0895 36.8229 65.6022 39.375 65.625C41.9043 65.625 44.2285 65.1123 46.3477 64.0869C48.4668 63.0615 50.3125 61.6943 51.8848 59.9854C53.457 58.2764 54.6761 56.3053 55.542 54.0723C56.4079 51.8392 56.8522 49.4922 56.875 47.0312V43.5449C55.599 43.2715 54.4255 42.8044 53.3545 42.1436C52.2835 41.4827 51.3607 40.6852 50.5859 39.751C49.8112 38.8167 49.2074 37.7458 48.7744 36.5381C48.3415 35.3304 48.125 34.0885 48.125 32.8125C48.125 31.3086 48.4098 29.8958 48.9795 28.5742C49.5492 27.2526 50.3239 26.1019 51.3037 25.1221C52.2835 24.1423 53.4456 23.3561 54.79 22.7637C56.1344 22.1712 57.5586 21.875 59.0625 21.875ZM59.0625 39.375C59.974 39.375 60.8285 39.2041 61.626 38.8623C62.4235 38.5205 63.1185 38.0534 63.7109 37.4609C64.3034 36.8685 64.7705 36.1735 65.1123 35.376C65.4541 34.5784 65.625 33.724 65.625 32.8125C65.625 31.901 65.4541 31.0465 65.1123 30.249C64.7705 29.4515 64.3034 28.7565 63.7109 28.1641C63.1185 27.5716 62.4235 27.1045 61.626 26.7627C60.8285 26.4209 59.974 26.25 59.0625 26.25C58.151 26.25 57.2965 26.4209 56.499 26.7627C55.7015 27.1045 55.0065 27.5716 54.4141 28.1641C53.8216 28.7565 53.3545 29.4515 53.0127 30.249C52.6709 31.0465 52.5 31.901 52.5 32.8125C52.5 33.724 52.6709 34.5784 53.0127 35.376C53.3545 36.1735 53.8216 36.8685 54.4141 37.4609C55.0065 38.0534 55.7015 38.5205 56.499 38.8623C57.2965 39.2041 58.151 39.375 59.0625 39.375Z'
			fill='white'
		/>
	</svg>
);

const NurseIcon = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='80'
		height='80'
		viewBox='0 0 80 50'
		fill='none'>
		<path
			d='M29.9482 26.8778H44.0518M37 19.7686V33.9835M37 2C17.1545 2 5.24056 13.9903 2.40222 17.2064C2.19767 17.4416 2.06436 17.731 2.01811 18.0403C1.97187 18.3496 2.01462 18.6657 2.14131 18.9513L15.0566 49.8633C15.4727 50.8601 16.6733 51.2742 17.6429 50.8086C20.8232 49.2787 27.9667 46.4215 37 46.4215C46.0333 46.4215 53.1768 49.2787 56.3571 50.8104C57.3267 51.2742 58.5273 50.8601 58.9434 49.8633L71.8587 18.9513C71.9854 18.6657 72.0281 18.3496 71.9819 18.0403C71.9356 17.731 71.8023 17.4416 71.5978 17.2064C68.7594 13.9903 56.8455 2 37 2Z'
			stroke='white'
			stroke-width='4'
			stroke-linecap='round'
			stroke-linejoin='round'
		/>
	</svg>
);

const MultiprofessionalIcon = () => (
	<svg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80' fill='none'>
		<circle cx='40' cy='25' r='12' stroke='white' strokeWidth='4' />
		<circle cx='18' cy='38' r='9' stroke='white' strokeWidth='4' />
		<circle cx='62' cy='38' r='9' stroke='white' strokeWidth='4' />
		<path d='M20 67C20 54 29 46 40 46C51 46 60 54 60 67M4 64C4 54 10 47 19 47M76 64C76 54 70 47 61 47' stroke='white' strokeWidth='4' strokeLinecap='round' />
	</svg>
);

const GearIcon = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='80'
		height='80'
		viewBox='0 0 80 80'
		fill='none'>
		<path
			d='M1.77911 49.462C1.90113 48.3315 2.74092 47.4215 4.42408 45.598L8.12057 41.5625C9.02855 40.4425 9.67095 38.5 9.67095 36.75C9.67095 35 9.02496 33.054 8.12416 31.9375L4.42408 27.902C2.74092 26.082 1.90113 25.1685 1.77911 24.038C1.65709 22.9075 2.28514 21.8435 3.54123 19.719L5.31411 16.7195C6.65274 14.4515 7.32385 13.3175 8.46151 12.8695C9.60276 12.4145 10.8911 12.7715 13.4679 13.4855L17.8463 14.686C19.4936 15.057 21.2198 14.847 22.7235 14.0945L23.9329 13.4155C25.2221 12.6093 26.213 11.4221 26.7609 10.0275L27.9596 6.538C28.7492 4.228 29.1439 3.073 30.077 2.408C31.0209 1.75 32.2698 1.75 34.7569 1.75H38.7584C41.2526 1.75 42.498 1.75 43.4346 2.4115C44.3749 3.073 44.7661 4.228 45.5556 6.538L46.7543 10.0275C47.3022 11.4221 48.2932 12.6093 49.5823 13.4155L50.7917 14.0945C52.2955 14.847 54.0217 15.057 55.6654 14.6895L60.0437 13.4855C62.6241 12.7715 63.9125 12.4145 65.0537 12.866C66.1914 13.321 66.8625 14.4515 68.2011 16.7195L69.974 19.719C71.2301 21.8435 71.8582 22.904 71.7325 24.038C71.6141 25.1685 70.7743 26.0785 69.0912 27.902L65.3947 31.9375C64.4867 33.054 63.8443 35 63.8443 36.75C63.8443 38.5 64.4903 40.446 65.3911 41.5625L69.0912 45.598C70.7743 47.418 71.6141 48.3315 71.7361 49.462C71.8582 50.5925 71.2301 51.6565 69.974 53.781L68.2011 56.7805C66.8625 59.0485 66.1914 60.1825 65.0537 60.6305C63.9125 61.0855 62.6241 60.7285 60.0473 60.0145L55.669 58.814C54.0214 58.4444 52.2929 58.6539 50.7882 59.4055L49.5823 60.0845C48.2903 60.8895 47.3034 62.0795 46.7543 63.4725L45.5556 66.962C44.7661 69.272 44.3713 70.427 43.4382 71.092C42.498 71.75 41.249 71.75 38.7584 71.75H34.7604C32.2662 71.75 31.0209 71.75 30.0842 71.0885C29.1439 70.427 28.7492 69.2755 27.9632 66.9655'
			stroke='white'
			stroke-width='3.5'
			stroke-linecap='round'
		/>
		<path
			d='M3.50559 60.4764C7.38153 56.6964 20.5597 43.9704 21.8517 42.5004C23.2154 40.9464 22.1101 38.8464 22.7704 32.3364C23.0862 29.1864 23.7825 26.8274 25.7707 25.0704C28.1393 22.8864 30.0773 22.8864 36.7525 22.7394C42.5664 22.8864 43.2555 22.2564 43.8584 23.7264C44.289 24.7764 42.9971 25.4064 41.4467 27.0864C38.0014 30.4464 35.9773 32.1264 35.7835 33.1764C34.3839 37.7964 39.8963 40.5264 42.9109 37.5864C44.0522 36.4734 49.3278 31.2864 49.8445 30.8664C50.2321 30.5304 51.1616 30.5444 51.6102 31.0764C51.9978 31.4474 52.0409 31.4964 51.9978 33.1764C51.9584 34.7304 51.9763 36.9634 51.9799 39.2664C51.9871 42.2484 51.8256 45.5664 50.5336 47.2464C47.9496 51.0264 43.643 51.2364 39.7671 51.4044C36.1065 51.6144 33.0919 51.2364 32.1444 51.9084C31.3693 52.2864 27.278 56.4864 22.3254 61.3164L13.4969 69.9264C6.17568 75.5964 -1.87765 66.7764 3.50559 60.4764Z'
			stroke='white'
			stroke-width='3.5'
			stroke-linecap='round'
		/>
	</svg>
);

const ReportIcon = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='80'
		height='80'
		viewBox='0 0 80 80'
		fill='none'>
		<path
			d='M18 10H62C65.3137 10 68 12.6863 68 16V64C68 67.3137 65.3137 70 62 70H18C14.6863 70 12 67.3137 12 64V16C12 12.6863 14.6863 10 18 10Z'
			stroke='white'
			strokeWidth='4'
		/>
		<path
			d='M25 25H50'
			stroke='white'
			strokeWidth='4'
			strokeLinecap='round'
		/>
		<path
			d='M25 38H55'
			stroke='white'
			strokeWidth='4'
			strokeLinecap='round'
		/>
		<path
			d='M25 51H47'
			stroke='white'
			strokeWidth='4'
			strokeLinecap='round'
		/>
		<path
			d='M54 10V24H68'
			stroke='white'
			strokeWidth='4'
			strokeLinejoin='round'
		/>
	</svg>
);

const cardBaseClass =
	'group flex w-[200px] min-h-[250px] flex-col items-center justify-between rounded-[8px] gap-4 bg-[#163B69] px-4 py-5 shadow-md transition duration-200 hover:scale-105 hover:shadow-lg';

function EscalaHub() {
	const [authChecked, setAuthChecked] = useState(false);
	const [hasUser, setHasUser] = useState(false);
	const [hasScaleManagementAccess, setHasScaleManagementAccess] =
		useState(false);
	const [hasCentralReportsAccess, setHasCentralReportsAccess] =
		useState(false);
	const [hasNursingScaleAccess, setHasNursingScaleAccess] = useState(false);
	const [hasMultiprofessionalScaleAccess, setHasMultiprofessionalScaleAccess] = useState(false);

	useEffect(() => {
		const rawUser = Cookies.get('user');
		if (!rawUser) {
			setHasUser(false);
			setHasScaleManagementAccess(false);
			setHasCentralReportsAccess(false);
			setHasNursingScaleAccess(false);
			setHasMultiprofessionalScaleAccess(false);
			setAuthChecked(true);
			return;
		}

		try {
			const parsedUser = JSON.parse(rawUser);
			const normalizeProfileValue = (value = '') =>
				String(value || '')
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
					.toLowerCase()
					.trim();
			const isCentralProfileValue = (value = '') => {
				const normalized = normalizeProfileValue(value);
				return (
					normalized === 'subhue' ||
					normalized === 'suhue' ||
					normalized === 'sms' ||
					normalized === 'sms rio' ||
					normalized === 'smsrio' ||
					normalized.includes('subhue') ||
					normalized.includes('sms rio')
				);
			};
			const cargo = normalizeProfileValue(parsedUser?.cargo);
			const unidade = normalizeProfileValue(parsedUser?.unidade);
			const usuario = normalizeProfileValue(
				parsedUser?.username || parsedUser?.nome || '',
			);
			const permissoes = Array.isArray(parsedUser?.permissao)
				? parsedUser.permissao
				: [parsedUser?.permissao].filter(Boolean);
			const isDeveloperProfile = cargo === 'desenvolvedor';
			const hasDeveloperPermission = permissoes.some(
				(permissao) =>
					normalizeProfileValue(permissao) === 'desenvolvedor',
			);
			const isSubhueProfile =
				cargo === 'subhue' ||
				unidade === 'subhue' ||
				usuario.includes('subhue') ||
				permissoes.some((permissao) =>
					normalizeProfileValue(permissao).includes('subhue'),
				);

			setHasUser(true);
			setHasScaleManagementAccess(
				isDeveloperProfile || hasDeveloperPermission || isSubhueProfile,
			);
			setHasCentralReportsAccess(
				isDeveloperProfile ||
					isCentralProfileValue(cargo) ||
					isCentralProfileValue(unidade) ||
					permissoes.some(isCentralProfileValue),
			);
			setHasNursingScaleAccess(canAccessEscalaEnfermagem(parsedUser));
			setHasMultiprofessionalScaleAccess(
				canAccessEscalaMultiprofissional(parsedUser),
			);
		} catch (_error) {
			setHasUser(false);
			setHasScaleManagementAccess(false);
			setHasCentralReportsAccess(false);
			setHasNursingScaleAccess(false);
			setHasMultiprofessionalScaleAccess(false);
		}

		setAuthChecked(true);
	}, []);

	const cards = useMemo(() => {
		const baseCards = [
			{
				id: 'medica',
				title: 'Escala Médica',
				to: '/escala-medica',
				icon: <StethoscopeIcon />,
			},
		];

		if (ESCALA_ENFERMAGEM_HABILITADA && hasNursingScaleAccess) {
			baseCards.push({
				id: 'enfermagem',
				title: 'Escala de Enfermagem',
				to: '/escala-enfermagem',
				icon: <NurseIcon />,
			});
		}

		if (
			ESCALA_MULTIPROFISSIONAL_HABILITADA &&
			hasMultiprofessionalScaleAccess
		) {
			baseCards.push({
				id: 'multiprofissional',
				title: 'Escala Multiprofissional',
				to: '/escala-multiprofissional',
				icon: <MultiprofessionalIcon />,
			});
		}

		if (hasCentralReportsAccess) {
			baseCards.push({
				id: 'relatorios',
				title: 'Relatorios',
				to: '/escala-relatorios',
				icon: <ReportIcon />,
			});
		}

		if (hasScaleManagementAccess) {
			baseCards.push({
				id: 'gerenciamento',
				title: 'Gerenciamento de Escala',
				to: '/escala-gerenciamento',
				icon: <GearIcon />,
			});
		}

		return baseCards;
	}, [
		hasCentralReportsAccess,
		hasNursingScaleAccess,
		hasMultiprofessionalScaleAccess,
		hasScaleManagementAccess,
	]);

	if (!authChecked) {
		return (
			<div className='flex flex-col min-h-screen'>
				<NavBar />
				<div className='flex flex-1 items-center justify-center bg-[#F0F4F8]'>
					<div className='w-8 h-8 rounded-full border-4 border-[#dbeafe] border-t-[#2563eb] animate-spin' />
				</div>
			</div>
		);
	}

	return (
		<div className='flex flex-col min-h-screen '>
			<NavBar />
			<div
				className='flex-1 mt-[80px]
       '>
				{!hasUser ? (
					<section className='bg-[#13335A] rounded-md mx-2 sm:w-[50%] mt-24 sm:mx-auto my-auto'>
						<div className='py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6'>
							<div className='mx-auto max-w-screen-sm text-center'>
								<h1 className='mb-4 text-white text-6xl tracking-tight font-extrabold lg:text-7xl'>
									401
								</h1>
								<p className='mb-10 text-3xl tracking-tight font-bold text-slate-100 md:text-4xl'>
									Acesso Negado
								</p>
								<p className='mb-7 text-lg font-light text-gray-300'>
									Você não possui permissão para acessar este
									campo.
								</p>
								<a
									href='/login'
									className='inline-flex hover:scale-105 transition-transform text-gray-300 bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-xl px-5 py-2.5 text-center my-4'>
									<span> Volte para a Tela de Login</span>
								</a>
							</div>
						</div>
					</section>
				) : (
					<div className='rounded-[2px] border-[#D7D7D7] bg-white shadow-sm font-inter'>
						<div className='bg-[#F0F4F8] px-6 py-[36px] text-center text-[26px] font-semibold text-[#13335A] sm:text-[28px]'>
							Escala de Profissionais
						</div>
						<div className='px-6  sm:px-10 sm:py-8 min-h-screen'>
							<div className='h-px w-full bg-[#D9D9D9]' />
							<div className='flex flex-wrap items-center justify-center gap-5 sm:gap-6 py-8 sm:py-10'>
								{cards.map((card) =>
									card.disabled ? (
										<div
											key={card.id}
											className='group relative flex w-[200px] min-h-[250px] flex-col items-center justify-between rounded-[8px] gap-4 bg-[#163B69] px-4 py-5 shadow-md opacity-50 cursor-not-allowed select-none'>
											<div className='flex flex-1 items-center justify-center'>
												{card.icon}
											</div>
											<div className='h-[2px] w-[95%] bg-[#D5DCE5]' />
											<p className='text-center text-[13px] leading-[1.2] text-white sm:text-[16px] min-h-[32px]'>
												{card.title}
											</p>
											<div className='pointer-events-none absolute bottom-[calc(100%+8px)] left-1/2 -translate-x-1/2 whitespace-nowrap rounded-[6px] bg-[#1e2a38] px-3 py-1.5 text-[12px] text-white opacity-0 transition-opacity group-hover:opacity-100'>
												Esta página ainda não está
												disponível
											</div>
										</div>
									) : card.external ? (
										<a
											key={card.id}
											href={card.to}
											className={cardBaseClass}
											target='_blank'
											rel='noreferrer'>
											<div className='flex flex-1 items-center justify-center '>
												{card.icon}
											</div>
											<div className='h-[2px] w-[95%] bg-[#D5DCE5]' />
											<p className='text-center text-[13px]  leading-[1.2] text-white sm:text-[16px] min-h-[32px]'>
												{card.title}
											</p>
										</a>
									) : (
										<Link
											key={card.id}
											to={card.to}
											className={cardBaseClass}>
											<div className='flex flex-1 items-center justify-center '>
												{card.icon}
											</div>
											<div className='h-[2px] w-[95%] bg-[#D5DCE5]' />
											<p className='text-center text-[13px]  leading-[1.2] text-white sm:text-[16px] min-h-[32px]'>
												{card.title}
											</p>
										</Link>
									),
								)}
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}

export default EscalaHub;
